import { AsyncStorageType } from "./types";

const throwNotImplemented = () => {
  throw new Error("The AsyncStorage API is not implemented for the default platform.");
};

const createAsyncStorage = (): AsyncStorageType => {
  const getItem = async () => {
    throwNotImplemented();
  };

  const setItem = async () => {
    throwNotImplemented();
  };

  const removeItem = async () => {
    throwNotImplemented();
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
};

export default createAsyncStorage();
